import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import ArrowIcon from '../resources/images/logos/SilverBoom Report.svg';

const RoundedIconTile = ({ title, secondaryText, icon, image, onClick, className, ...rest }) => {
  const theme = useTheme();

  return (
    <Box
      className={className}
      onClick={onClick}
      {...rest}
      sx={{
        width: 220,
        minHeight: 220,
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '22px',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '24px',
        transition: 'all .2s ease',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
          transform: 'translateY(-2px)'
        }
      }}>
      {/* Icon */}
      <Box
        sx={{
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        {image ? (
          <Box
            component="img"
            src={image}
            alt={title}
            sx={{
              width: 75,
              height: 75,
              objectFit: 'contain'
            }}
          />
        ) : (
          icon
        )}
      </Box>

      {/* Title */}
      <Box
        sx={{
          width: '100%',
          minHeight: 48, // Reserve space for up to 2 lines
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center'
        }}>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 700,
            color: theme.palette.text.primary,
            lineHeight: 1.4
          }}>
          {title}
        </Typography>
      </Box>

      {/* Secondary Text */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          textAlign: 'center',
          minHeight: 40 // Reserve space for up to 2 lines
        }}>
        <Typography
          sx={{
            fontSize: '12px',
            color: theme.palette.text.secondary,
            lineHeight: 1.4
          }}>
          {secondaryText}
        </Typography>
      </Box>

      {/* Arrow */}
      <Box
        component="img"
        src={ArrowIcon}
        alt="Navigate"
        sx={{
          width: 36,
          height: 46,
          alignSelf: 'flex-end',
          mt: 'auto',
          pt: '24px'
        }}
      />
    </Box>
  );
};

export default RoundedIconTile;
